import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { ClockRewindIcon } from 'app/components/shared/icons';
import { setPrompt } from 'store/reducers/nlp/nlp-reducer';

import { PeopleSearchContext } from '../../PeopleSearchContext';
import usePeopleSearchHistory from '../../usePeopleSearchHistory';
import {
  PeopleSearchBarHistoryClearButtonContainer,
  PeopleSearchBarHistoryClearCTA,
  PeopleSearchBarHistoryItem,
  PeopleSearchBarHistoryItemDate,
  PeopleSearchBarHistoryItemLabel,
  PeopleSearchBarHistoryList,
  PeopleSearchBarHistoryWrapper,
} from './styled';

export default function PeopleSearchBarHistory() {
  const dispatch = useDispatch();
  const context = useContext(PeopleSearchContext);
  const { getSearches, clearSearches } = usePeopleSearchHistory();

  const groupedSearches = useMemo(() => {
    const searches = getSearches();

    return searches.reduce((acc, search) => {
      const date = new Date(search.timestamp);
      const key = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      acc[key] = acc[key] || [];
      acc[key].push(search);

      return acc;
    }, {});
  }, [getSearches]);

  const handleClearHistory = () => {
    clearSearches();
    context.setShowHistory(false);
  };

  const handleClick = (search: string) => {
    dispatch(setPrompt(search));
    context.setShowHistory(false);
  };

  return (
    <PeopleSearchBarHistoryWrapper data-id="people-search-bar-history">
      <PeopleSearchBarHistoryClearButtonContainer>
        <PeopleSearchBarHistoryClearCTA onClick={handleClearHistory}>
          CLEAR HISTORY
        </PeopleSearchBarHistoryClearCTA>
      </PeopleSearchBarHistoryClearButtonContainer>
      <PeopleSearchBarHistoryList>
        {Object.keys(groupedSearches).map((date) => (
          <React.Fragment key={date}>
            <PeopleSearchBarHistoryItemDate>{date}</PeopleSearchBarHistoryItemDate>
            {groupedSearches[date].map((search, index) => (
              <PeopleSearchBarHistoryItem
                key={`${search.search}-${index}`}
                onClick={() => handleClick(search.search)}
              >
                <ClockRewindIcon />
                <PeopleSearchBarHistoryItemLabel>{search.search}</PeopleSearchBarHistoryItemLabel>
              </PeopleSearchBarHistoryItem>
            ))}
          </React.Fragment>
        ))}
      </PeopleSearchBarHistoryList>
    </PeopleSearchBarHistoryWrapper>
  );
}
